import { render, staticRenderFns } from "./ControleSubsidio.vue?vue&type=template&id=4c417861&"
import script from "./ControleSubsidio.vue?vue&type=script&lang=js&"
export * from "./ControleSubsidio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports